import { Link } from "react-router-dom";
import "./Footer.css";

const ROUTES = {
  home:           "/",
  services:       "/services",
  about:          "/about",
  "track-record": "/track-record",
  network:        "/network",
  "why-us":       "/why-us",
  insights:       "/insights",
  contact:        "/contact",
};

export default function Footer({ brand, footer }) {
  return (
    <footer className="footer">
      <div className="ft-top wrap">
        <div className="ft-brand">
          <Link to="/" className="ft-logo">
            {brand?.logoImage
              ? <img src={brand.logoImage} alt={brand.name} style={{ height:50, width:"auto", filter:"brightness(0) invert(1)" }} />
              : brand?.logoText}
          </Link>
          <p>{footer?.tagline}</p>
          <div className="ft-soc">
            {Object.entries(footer?.social || {}).map(([k, v]) => (
              <a key={k} href={v} target="_blank" rel="noreferrer">{k}</a>
            ))}
          </div>
        </div>

        {footer?.columns?.map(col => (
          <div className="ft-col" key={col.heading}>
            <h4>{col.heading}</h4>
            <ul>
              {col.links?.map(link => (
                <li key={link.label}>
                  {link.page
                    ? <Link to={ROUTES[link.page] || "/"}>{link.label}</Link>
                    : <a href={link.href}>{link.label}</a>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="ft-btm wrap">
        <p>{footer?.copyright}</p>
        <p>{footer?.credit}</p>
      </div>
    </footer>
  );
}
